import PropTypes from 'prop-types';
import { useTabsContext } from '../Tabs';

export const TabPanel = ({
  isActive = false,
  children,
  className,
  ...rest
}) => {
  const { onSelectTab } = useTabsContext();
  const panelProps = {
    role: 'tabpanel',
    className: className,
    style: {
      ...(!isActive && { display: 'none' }),
    },
    'aria-hidden': !isActive,
    ...rest,
  };

  return (
    <div data-testid="tabpanel" {...panelProps}>
      {typeof children === 'function'
        ? children({ selectTab: onSelectTab, isActive })
        : children}
    </div>
  );
};

TabPanel.displayName = 'TabPanel';
TabPanel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  isActive: PropTypes.bool,
  className: PropTypes.string,
};
